// Custom JavaScript voor GRIXX

/*==================================================
  Thuiswinkel Widget
==================================================*/

document.addEventListener('DOMContentLoaded', function () {
  var thuiswinkelWidget = document.querySelector(
    '.footer-thuiswinkel, .tww_popup_wrapper_NTkzMi0xMA\\=\\='
  );

  if (!thuiswinkelWidget) {
    return;
  }

  function loadThuiswinkelScript() {
    if (window.thuiswinkelScriptLoaded) {
      return;
    }

    window.thuiswinkelScriptLoaded = true;

    var script = document.createElement('script');
    script.src = 'https://widget.thuiswinkel.org/script.js?id=NTkzMi0xMA==';
    script.async = true;

    document.body.appendChild(script);
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadThuiswinkelScript();
          observer.disconnect();
        }
      });
    }, {
      rootMargin: '100px'
    });

    observer.observe(thuiswinkelWidget);
  } else {
    loadThuiswinkelScript();
  }
});

